export const FORMIO_DATA_CLASS_PREFIX = "formio-component-formSubmissionDataRSTsection"
export const COMPLETTION_SECTION_ID = "section-completion-id"
export const COMPLETTION_SECTION_KEY = "section-completion-key"
